import React from 'react';
import { Route } from 'react-router-dom';
import { createLazyRoute } from '@core/router';

const homePageRoute = () => import('./HomePage');

const homeRoutes = <Route path="/" {...createLazyRoute(homePageRoute, m => m.default)} />;

export default homeRoutes;
